import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Users, Calendar, BookOpen, Activity, Building2, CreditCard, UserCheck, FileText } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { getStorageUrl } from '../utils/storageUrl';

const Sidebar = () => {
  const location = useLocation();
  const { user } = useAuth();

  const menuItems = [
    {
      name: 'Socios',
      path: '/dashboard',
      icon: Users,
      description: 'Gestión de socios'
    },
    {
      name: 'Usuarios',
      path: '/users',
      icon: UserCheck,
      description: 'Gestión de usuarios'
    },
    {
      name: 'Club',
      path: '/club',
      icon: Building2,
      description: 'Información del club'
    },
    {
      name: 'Tarifas',
      path: '/pricing',
      icon: CreditCard,
      description: 'Gestión de tarifas'
    },
    {
      name: 'Inscripciones',
      path: '/subscriptions',
      icon: FileText,
      description: 'Control de inscripciones'
    },
    {
      name: 'Eventos',
      path: '/events',
      icon: Calendar,
      description: 'Gestión de eventos'
    },
    {
      name: 'Clases',
      path: '/classes',
      icon: BookOpen,
      description: 'Gestión de clases'
    },
    {
      name: 'Entrenamientos',
      path: '/trainings',
      icon: Activity,
      description: 'Gestión de entrenamientos'
    }
  ];

  // Obtener el logo del club si el usuario tiene un club asociado
  const clubLogo = user?.club?.logo;
  const clubName = user?.club?.name;
  const isSuperAdmin = user?.role?.name === 'super_admin';
  
  // Construir la URL completa del logo si es relativa
  const getLogoUrl = () => {
    return getStorageUrl(clubLogo);
  };

  const logoUrl = getLogoUrl();
  const [logoError, setLogoError] = React.useState(false);

  return (
    <div className="w-64 bg-white shadow-lg min-h-screen">
      <div className="p-6">
        <div className="mb-8">
          {!isSuperAdmin && logoUrl && !logoError ? (
            <div className="flex items-center justify-center">
              <img 
                src={logoUrl} 
                alt={clubName || 'Logo del club'} 
                className="h-16 w-auto object-contain max-w-full"
                onError={() => setLogoError(true)}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <img 
                src="/logo.png" 
                alt="TrailClubs" 
                className="h-16 w-16 object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <h2 className="text-xl font-bold text-gray-800" style={{ display: 'none' }}>TrailClubs</h2>
            </div>
          )}
        </div>
        
        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActive
                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <Icon 
                  size={20} 
                  className={`mr-3 ${
                    isActive ? 'text-blue-700' : 'text-gray-500'
                  }`} 
                />
                <div>
                  <div className="font-medium">{item.name}</div>
                  <div className="text-xs text-gray-500">{item.description}</div>
                </div>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
